// External Modal Container Component - iframe-based modal loader with status tracking
import { Component, OnInit } from '@angular/core';
import { ModalComponentInterface } from '../modal/modal-component.interface';
import { ExternalModalViewModel } from '../../view-models/modal/external-modal-view-model';
import { ActivatedRoute } from '@angular/router';
import { IframeWithTabCommunicationComponent } from '../iframe-with-tab-communication/iframe-with-tab-communication.component';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { StatusMessageInterface, TabSocket } from '@nts/std/utility';

@Component({
    selector: 'nts-external-modal-container',
    templateUrl: 'external-modal-container.component.html',
    styleUrls: ['./external-modal-container.component.scss'],
    standalone: true,
    imports: [
        IframeWithTabCommunicationComponent
    ]
})

export class ExternalModalContainerComponent implements OnInit, ModalComponentInterface {

    viewModel: ExternalModalViewModel;
    inIframe: boolean = false;
    iframeLoaded: BehaviorSubject<{
        iframe: HTMLIFrameElement,
        frameInstanceId: string,
        tabSocket: TabSocket,
    }> = new BehaviorSubject<any>(null);
    url: string;

    constructor(private route: ActivatedRoute) { }

    ngOnInit(): void {
        if (this.route.snapshot.queryParams['iframe'] != null) {
            this.inIframe = this.route.snapshot.queryParams['iframe'] === 'true';
        }
        this.viewModel.initialize(async (iframeUrl: string) => {
            this.url = iframeUrl;
            // Wait for iframe to load
            await firstValueFrom(this.iframeLoaded.pipe(filter(x => x != null)), { defaultValue: null });

            return this.iframeLoaded.value;
        });
    }

    onStatusPush(status: StatusMessageInterface): void {
        if (this.viewModel && typeof this.viewModel.onStatusPush === 'function') {
            this.viewModel.onStatusPush(status);
        }
    }
}
